import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "add-device-to-linkable-object wizard-panels" }
const _hoisted_2 = { class: "wizard-panels__left" }
const _hoisted_3 = { class: "devices-list" }
const _hoisted_4 = { class: "wizard-panels__right p-4" }
const _hoisted_5 = { class: "d-flex mb-3" }
const _hoisted_6 = { class: "p-input-icon-left ml-auto input-filter-search" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_8 = { class: "devices-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeviceAndSlotDetail = _resolveComponent("DeviceAndSlotDetail")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", null, _toDisplayString(_ctx.$t("AppResource.SelectManuallyFromList")), 1),
      _createVNode(_component_ElScrollbar, null, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentDevices, (device, index) => {
              return (_openBlock(), _createBlock(_component_DeviceAndSlotDetail, {
                device: device,
                key: device.id,
                onRemoveDevice: ($event: any) => (_ctx.removeDevice(index)),
                class: "flex-basis-1",
                isSingleDeviceSelection: _ctx.isSingleDeviceSelection,
                isOnlyDeviceSelection: _ctx.isOnlyDeviceSelection,
                linkableObject: _ctx.linkableObject,
                ruleServiceType: _ctx.ruleServiceType
              }, null, 8, ["device", "onRemoveDevice", "isSingleDeviceSelection", "isOnlyDeviceSelection", "linkableObject", "ruleServiceType"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_TabView, { class: "p-tabview--custom" }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('assignObject.selectFromLastScan')
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_InputText, {
                    type: "text",
                    placeholder: _ctx.$t('AppResource.FilterByText'),
                    modelValue: _ctx.searchTerm,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchTerm = $event))
                  }, null, 8, ["placeholder", "modelValue"])
                ])
              ]),
              _createVNode(_component_ElScrollbar, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_8, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableAssignableDevices, (device) => {
                      return (_openBlock(), _createBlock(_component_DeviceAndSlotDetail, {
                        device: device,
                        key: device.id,
                        class: "flex-basis-1",
                        onAddDevice: _ctx.addDevice,
                        "is-add": true,
                        isSingleDeviceSelection: 
                                    _ctx.isSingleDeviceSelection
                                ,
                        isOnlyDeviceSelection: _ctx.isOnlyDeviceSelection,
                        linkableObject: _ctx.linkableObject,
                        ruleServiceType: _ctx.ruleServiceType
                      }, null, 8, ["device", "onAddDevice", "isSingleDeviceSelection", "isOnlyDeviceSelection", "linkableObject", "ruleServiceType"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('assignObject.selectFromCatalogue')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("assignObject.selectFromCatalogue")), 1)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      })
    ])
  ]))
}